// --- Vendors ---
import 'jquery.marquee';
import Swiper from 'swiper';

// --- Components ---
const home = {
    readyFn: function () {
        $('.marquee').marquee({
            duration: 5000,
            gap: 0,
            duplicated: true,
            duplicateCount: 3,
            pauseOnHover: true,
        });

        const swiperSelection = new Swiper('.selectionSwiper', {
            spaceBetween: 10,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        const swiperFluid = new Swiper('.swiper-fluid', {
            spaceBetween: 10,
            slidesPerView: 1.2,
            breakpoints: {
                1200: {
                    slidesPerView: 3.2
                }
            }
        });
    }
}
export { home };